module.exports = __webpack_public_path__ + "static/media/bod05.c723cc6b.jpg";